export default "__VITE_ASSET__d62d83cc__"